import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

const PrivateRoute = ({ component: Component }) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const handleLogin = () => {
    instance.loginRedirect();
  };
  return (
    <>
      {isAuthenticated ? <Component /> : <Button onClick={handleLogin} variant="success">Vui lòng đăng nhập</Button>}
    </>
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired
};

export default PrivateRoute;
